import { NgClass } from '@angular/common';
import { Component, Input, OnInit, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDivider } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { Router, RouterLink, RouterOutlet } from '@angular/router';
import { ThemeService } from '../../services/theme.service';
import { AuthService } from '../../services/auth.service';
import { AdministrationService } from '../../services/administration.service';
import { UserPhoto } from '../../models/User';
import { MatCardModule } from '@angular/material/card';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PruebasService } from '../../services/pruebas.service';

@Component({
  selector: 'app-user-menu',
  imports: [
    RouterLink,
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatSidenavModule,
    MatListModule,
    MatDivider,
    MatMenuModule,
    MatTooltipModule,
    MatExpansionModule,
    MatCardModule
  ],
  templateUrl: './user-menu.component.html',
  styleUrl: './user-menu.component.scss'
})
export class UserMenuComponent implements OnInit {
  @Input() isMobile?: boolean;
  /*Manejo de thema*/
  themeService: ThemeService = inject(ThemeService);
  toogleTheme = () => this.themeService.updateTheme();
  hasAdminRole = false

  username: string = ""
  userMiniature: UserPhoto | undefined
  miniaturePath: SafeResourceUrl | undefined

  constructor(
    private authService: AuthService,
    private administrationService: AdministrationService,
    private _sanitizer: DomSanitizer
    ,
    private pruebasService: PruebasService
  ) {
    var tokenData = authService.getTokenData()
    if (tokenData) {
      if (tokenData.roles.includes("sgd_admin")) {
        this.hasAdminRole = true
      }
    }
  }

  ngOnInit(): void {
    this.username = this.authService.getTokenData()!.name
    this.administrationService.GetCurrentUserMiniature().subscribe({
      next: (response) => {
        this.userMiniature = response
        this.miniaturePath = this._sanitizer.bypassSecurityTrustResourceUrl('data:image/jpg;base64,'
          + this.userMiniature.foto);
      }
    })
    this.pruebasService.pruebasUrl$.subscribe(url => {
      this.pruebasUrl = url;
    });
  }

  pruebasUrl?: string;

  openPruebas(): void {
    if (this.pruebasUrl) {
      window.open(this.pruebasUrl, '_blank');
    }
  }

  setColor(color: string) {
    this.themeService.updateTheme(color)
  }

  logout(): void {
    this.authService.logout()
  }
}
